<template>
  <div class="bg-putty md:py-24 py-12">
    <div class="container">
      <h2 class="w-full text-center">{{ $t('education.findTraining') }}</h2>
      <div class="md:my-10 flex flex-wrap mt-5 mb-0">
        <div class="md:w-1/2 w-full">
          <div class="md:w-3/4 w-full">
            <ModelSelect
              v-if="cityOptions.length > 1"
              v-model="currentCity"
              :options="cityOptions"
              :placeholder="$t('education.enterLocation')"
              class="education-dropdown"
            >
              <label>{{ $t('education.enterLocation') }}</label>
            </ModelSelect>
          </div>
        </div>
        <ul class="md:w-1/2 flex flex-row justify-between w-full py-5">
          <li class="md:block fluid-sm leading-tightest hidden font-semibold">{{ $t('education.filterBy') }}</li>
          <li class="filter-item">
            <span :class="{ 'text-br-green': !currentAttendance }" @click="setFilter(null)">{{
              $t('education.all')
            }}</span>
          </li>
          <li v-for="(filter, index) in attendanceOptions" :key="'filter_' + index" class="filter-item">
            <span :class="{ 'text-br-green': filter === currentAttendance }" @click="setFilter(filter)">{{
              $t('education.' + filter)
            }}</span>
          </li>
        </ul>
      </div>

      <div v-for="(event, index) in filteredEvents" :key="'event_' + index">
        <h3
          v-if="isNewSection(event.city)"
          class="fluid-sm tracking-wider px-3 py-3 mt-5 mb-2 font-normal text-white bg-black"
        >
          {{ event.city || $t('education.online') }}
        </h3>
        <TrainingEvent :event="event" />
      </div>
      <div v-if="!filteredEvents.length" class="fluid-sm tracking-wider font-medium w-full text-center">
        {{ $t('education.noResults') }}
      </div>
    </div>
  </div>
</template>
<script>
import TrainingEvent from '@/components/education/TrainingEvent';
import { ModelSelect } from 'vue-search-select';
import 'vue-search-select/dist/VueSearchSelect.css';

export default defineNuxtComponent({
  components: {
    TrainingEvent,
    ModelSelect,
  },
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    entryId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      currentCity: null,
      currentAttendance: null,
    };
  },

  currentSection: null,

  computed: {
    relatedEvents() {
      return this.events.reduce((acc, event) => {
        const schedule = event.schedule?.filter((schedule) => {
          return schedule.educationType?.length && schedule.educationType[0].id === this.entryId;
        });
        if (schedule?.length) acc.push({ ...event, schedule });
        return acc;
      }, []);
    },
    cityOptions() {
      const cities = [...new Set(this.relatedEvents.map((e) => e.city))].filter(Boolean);
      const resetOption = { value: '-', text: this.$t('education.all') };
      return [resetOption, ...cities.map((city) => ({ value: city, text: city }))];
    },
    attendanceOptions() {
      return [...new Set(this.relatedEvents.map((event) => event.attendance))];
    },
    eventsByCity() {
      if (this.currentCity === '-' || !this.currentCity) {
        return this.relatedEvents;
      }
      return this.relatedEvents.filter((event) => event.city === this.currentCity);
    },
    eventsByAttendance() {
      if (!this.currentAttendance) return this.eventsByCity;
      return this.eventsByCity.filter((event) => event.attendance === this.currentAttendance);
    },
    filteredEvents() {
      return [...this.eventsByAttendance].sort((a, b) => ('' + a.city).localeCompare(b.city));
    },
  },

  watch: {
    currentCity() {
      this.resetSection();
    },
  },

  methods: {
    resetSection() {
      this.$options.currentSection = null;
    },
    setFilter(filter) {
      this.resetSection();
      if (filter && filter.search('online') >= 0) {
        this.currentCity = '';
      }
      this.currentAttendance = filter;
    },
    isNewSection(section) {
      const show = section !== this.$options.currentSection;
      this.$options.currentSection = section;
      return show;
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.filter-item {
  @apply font-semibold cursor-pointer fluid-sm leading-tightest;
}
.ui.selection.dropdown.education-dropdown {
  @apply border-none py-5;
  &:not(.active) {
    @apply rounded-full;
  }
}
.ui.selection.dropdown.education-dropdown :deep(.menu) {
  @apply border-none shadow-xl;
}
.ui.selection.dropdown.education-dropdown :deep(.search) {
  @apply py-5;
}
.ui.selection.dropdown.education-dropdown :deep(.icon) {
  @apply p-5;
}
</style>
